import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
} from '@mui/material';
import axios from 'axios';
import { local_signage } from '../../Const';

const SearchModal = ({ open, onClose, onSearch, initialSearchTerm = '' }) => {
  const [searchCriteria, setSearchCriteria] = useState({
    customerName: '',
    city: '',
    state: '',
    branchId: '',
    mobileNumber: '',
  });
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);

  // Get token from localStorage
  const token = localStorage.getItem('AuthorizationToken');

  useEffect(() => {
    if (open) {
      setSearchCriteria(prev => ({
        ...prev,
        customerName: initialSearchTerm,
      }));
    }
  }, [open, initialSearchTerm]);

  useEffect(() => {
    // Fetch states from API with token
    const fetchStates = async () => {
      try {
        const response = await axios.get(`${local_signage}/api/v1/state`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setStates(response.data);
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };
    fetchStates();
  }, [token]);

  const fetchCities = async stateCode => {
    setLoadingCities(true);
    try {
      const response = await axios.get(`${local_signage}/api/v1/city?StateCode=${stateCode}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCities(response.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    } finally {
      setLoadingCities(false);
    }
  };

  const handleInputChange = field => event => {
    const value = event.target.value;
    setSearchCriteria(prev => ({
      ...prev,
      [field]: value,
    }));

    if (field === 'state') {
      setSearchCriteria(prev => ({
        ...prev,
        city: '', // Clear city selection when state changes
      }));
      fetchCities(value); // Fetch cities for the selected state
    }
  };

  const handleSearch = () => {
    onSearch(searchCriteria);
    onClose();
  };

  const handleClear = () => {
    setSearchCriteria({
      customerName: initialSearchTerm, // Keep the customer name
      city: '',
      state: '',
      branchId: '',
      mobileNumber: '',
    });
    setCities([]); // Clear cities when clearing form
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className="bg-green-50 text-gray-800">Advanced Search</DialogTitle>
      <DialogContent className="mt-4">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Customer Name"
              value={searchCriteria.customerName}
              onChange={handleInputChange('customerName')}
              size="small"
              className="bg-green-50"
            />
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small" className="bg-green-50">
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                value={searchCriteria.state}
                onChange={handleInputChange('state')}
                label="State"
              >
                {states.map(state => (
                  <MenuItem key={state.StateCode} value={state.StateCode}>
                    {state.StateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small" className="bg-green-50">
              <InputLabel id="city-label">City</InputLabel>
              <Select
                labelId="city-label"
                value={searchCriteria.city}
                onChange={handleInputChange('city')}
                label="City"
                disabled={loadingCities || cities.length === 0}
              >
                {loadingCities ? (
                  <MenuItem disabled>
                    <CircularProgress size={20} />
                  </MenuItem>
                ) : (
                  cities.map(city => (
                    <MenuItem key={city.CityCode} value={city.CityCode}>
                      {city.CityName}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid> */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Branch ID"
              value={searchCriteria.branchId}
              onChange={handleInputChange('branchId')}
              size="small"
              className="bg-green-50"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Mobile Number"
              value={searchCriteria.mobileNumber}
              onChange={handleInputChange('mobileNumber')}
              size="small"
              className="bg-green-50"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="bg-gray-50 p-4">
        <Button onClick={handleClear} variant="outlined" className="text-gray-600">
          Clear
        </Button>
        <Button onClick={handleSearch} variant="contained" className="bg-green-600 hover:bg-green-700 text-white">
          Search
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchModal;
